import { useMemo } from 'react';

function generateRandomTrendData(categories) {
  // Generate data for 12 months
  const months = [
    'Jan 2024', 'Feb 2024', 'Mar 2024', 'Apr 2024', 
    'May 2024', 'Jun 2024', 'Jul 2024', 'Aug 2024', 
    'Sep 2024', 'Oct 2024', 'Nov 2024', 'Dec 2024'
  ];

  return months.map(month => {
    const monthData = { month };

    categories.forEach(category => {
      // Generate more varied and consistent data
      const basePositive = 40 + Math.floor(Math.random() * 20);
      const baseNegative = 20 + Math.floor(Math.random() * 20);
      const baseNeutral = 100 - basePositive - baseNegative;

      monthData[`${category}_sentiment_positive`] = Math.max(0, Math.min(100, basePositive + Math.floor(Math.random() * 10 - 5)));
      monthData[`${category}_sentiment_negative`] = Math.max(0, Math.min(100, baseNegative + Math.floor(Math.random() * 10 - 5)));
      monthData[`${category}_sentiment_neutral`] = Math.max(0, Math.min(100, baseNeutral + Math.floor(Math.random() * 10 - 5)));
    });

    return monthData;
  });
}

function useCategoryTrend(reviews, filters = {}) {
  const {
    selectedRegion = 'global',
    selectedCity = '',
    dateRange = [null, null],
    showLocations = true,
    showProducts = true,
    showApps = true
  } = filters;

  // If no reviews or development mode, generate random data
  if (!reviews || reviews.length === 0) {
    const mockCategories = [
      'Product Quality', 
      'Customer Service', 
      'Delivery & Shipping', 
      'App Experience', 
      'Price & Value'
    ];
    return generateRandomTrendData(mockCategories);
  }

  // Rest of the existing trend data generation logic...
  // (Keep the existing implementation for when real data is available)
  const filteredReviews = reviews.filter(review => {
    // Region filter
    const regionMatch = selectedRegion === 'global' || review.region === selectedRegion;
    
    // City filter
    const cityMatch = !selectedCity || review.city === selectedCity;
    
    // Date range filter
    const dateMatch = (!dateRange[0] || new Date(review.date) >= dateRange[0]) && 
                      (!dateRange[1] || new Date(review.date) <= dateRange[1]);
    
    // Source filters
    const sourceMatch = 
      (showLocations && review.source === 'Google Reviews') ||
      (showProducts && review.source === 'Amazon') ||
      (showApps && (review.source === 'App Store' || review.source === 'Play Store'));
    
    return regionMatch && cityMatch && dateMatch && sourceMatch;
  });

  // Generate trend data (similar to previous implementation)
  const trendData = generateRandomTrendData(
    [
      'Product Quality', 
      'Customer Service', 
      'Delivery & Shipping', 
      'App Experience', 
      'Price & Value'
    ]
  );

  return trendData;
}

export default useCategoryTrend;